import React from 'react';

import { Checkbox, Text, Tooltip, rem } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

type AgeCertificationProps = {
  overEighteenCertification: boolean;
  setOverEighteenCertification: (value: boolean) => void;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
  isFullScreen: boolean;
  shouldShowAgeCertification: boolean;
  isInvalid: boolean;
  setAgeCertificationInvalid: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AgeCertificationCheckbox = ({
  overEighteenCertification,
  setOverEighteenCertification,
  setError,
  isFullScreen,
  shouldShowAgeCertification,
  isInvalid,
  setAgeCertificationInvalid,
}: AgeCertificationProps) => {
  if (!shouldShowAgeCertification) {
    return null;
  }

  const checkboxStyle = isFullScreen ? {} : { marginTop: '-25px', marginBottom: '10px' };
  const textVariant = isFullScreen ? 'body-sm' : 'body-md';
  const colorVariant = isFullScreen ? 'text-secondary' : 'gray.600';

  return (
    <Checkbox
      size="md"
      isChecked={overEighteenCertification}
      onChange={(e) => {
        setOverEighteenCertification(e.target.checked);
        setError(null);
        setAgeCertificationInvalid(false);
      }}
      id="self_certification_checkbox"
      style={checkboxStyle}
      isInvalid={isInvalid}
    >
      <Tooltip
        label={translate('You must be 18 or older to sign up or use our services in your area.')}
        placement={'top'}
        maxWidth={rem(265)}
      >
        <Text variant={textVariant} display="inline" color={colorVariant}>
          {translate("By checking this box, I certify that I'm 18 or older.")}
        </Text>
      </Tooltip>
    </Checkbox>
  );
};
